var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('main-input-container',{attrs:{"lock-text":_vm.$route.params.lockText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }